var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C13.9609 -6.00908e-08 9.12816 2.00178 5.56497 5.56497C2.00178 9.12816 4.40533e-07 13.9609 0 19C-4.40533e-07 24.0391 2.00178 28.8718 5.56497 32.435C9.12816 35.9982 13.9609 38 19 38L19 19V0Z",
    fill: "#719A5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C21.4951 0 23.9658 0.491449 26.271 1.44629C28.5762 2.40113 30.6707 3.80066 32.435 5.56497C34.1993 7.32928 35.5989 9.42383 36.5537 11.729C37.5086 14.0342 38 16.5049 38 19L19 19L19 0Z",
    fill: "#91C577"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38C21.4951 38 23.9658 37.5086 26.271 36.5537C28.5762 35.5989 30.6707 34.1993 32.435 32.435C34.1993 30.6707 35.5989 28.5762 36.5537 26.271C37.5086 23.9658 38 21.4951 38 19L19 19L19 38Z",
    fill: "#B2E19C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPlan);
export default __webpack_public_path__ + "static/media/PlusPlan.2b82fd0fe629f749ea1bc2b60121f339.svg";
export { ForwardRef as ReactComponent };